'use client';

import { DotLottieReact } from '@lottiefiles/dotlottie-react';
import Link from 'next/link';
import React from 'react';

const HomeHero = () => {
    return (
        <div className="container lg:container md:mx-auto top-hero ">
            <div className=" gap-4 z-[1] relative h-full flex items-center overflow-visible">
                <div className="w-[75%] sm:w-full md:w-[75%]">
                    <div className="inline-flex flex-col lg:items-start gap-5 hero-content justify-center h-full ">
                        <p className="m-0">
                            {' '}
                            <div className="text-4xl sm:text-2xl md:text-4xl fw-700 text-[--bs-body-color] leading-[50px] ">
                                Leaders in
                            </div>
                        </p>
                        <h1 className=" my-0 text-primary text-5xl sm:text-3xl md:text-5xl leading-[58px] font-bold">
                            Custom Software Development & System Integrations Services
                        </h1>
                        <p className=" mb-0 font-semibold text-xl sm:text-base md:text-xl text-[--bs-secondary]">
                            We are specialized in custom software development, system integration, and IT consulting. Our expert
                            team excels in mobile app development, web application development, and API integration services.
                            {`Let's`}build something extraordinary together with our cutting-edge software solutions.
                        </p>
                        <div>
                            <Link href="contact-us" className="btn btn-primary w-full">
                                {"Let's Discuss Your Project"}
                            </Link>
                        </div>
                    </div>
                </div>
                <div className="absolute top-[-400px] right-[-250px] sm:right-[-220px] md:right-[-200px] sm:top-[-380px] md:top-[-310px] lg:top-[-270px] lg:right-[-250px]">
                    <DotLottieReact
                        src="https://lottie.host/04084437-15e0-47c9-89ee-c128e9dad3b2/yGtcu1lbS7.json"
                        backgroundColor="none"
                        speed={0.5}
                        className="w-[900px] h-[1000px] sm:w-[480px] sm:h-[1000px] md:w-[700px] md:h-[1000px] lg:w-[900px]"
                        autoplay
                    />
                </div>
            </div>
        </div>
    );
};

export default HomeHero;
